// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/ff915f0e9b57b68c46a8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f9b9b08315aa512c8ae1","159":"b6df26442b928fabc442","160":"e04e577295e3bd3e459c"}[chunkId] + ".chunk.js";
};